<template>
  <div class="not-allowed-page-container">
    <div class="not-allowed-page">

      <success-failure-display :message="texts.message"
                               :hint="texts.hint"
                               error />

    </div>
  </div>
</template>


<script>
import SuccessFailureDisplay from "@/components/SuccessFailureDisplay";

export default {
  name: "NotAllowedPage",
  components: { SuccessFailureDisplay },
  props: {
    message: {
      type: String,
      required: false,
      default: ""
    },
    hint:{
      type: String,
      required: false,
      default: ""
    },
    messageid: {
      type: String,
      required: false,
      default: ""
    }
  },
  computed: {
    texts() {
      switch (this.messageid) {
        case "iat": {
          return {
            message: "Aktion mit diesem User nicht möglich.",
            hint:"Bitte melden Sie sich mit Ihrer alternativen Maklernummer im Maklerportal an, um Abschlüsse einzureichen."
          };
        }
        default: {
          return {
            message: this.message || "Diese Aktion ist nicht erlaubt",
            hint: this.hint || ""
          };
        }
      }
    }
  }
};
</script>

<style>
.not-allowed-page-container {
  margin: 0 48px 100px 48px;
  display: flex;
  justify-content: center;
}

.not-allowed-page {
  max-width: 768px;
  width: 100%;
  font-size: 16px !important;
}
</style>
